export interface IRange {
  startIndex: number;
  endIndex: number;
  overscan: number;
  count: number;
}
export const defaultRangeExtractor = (range: IRange) => {
  const start = Math.max(range.startIndex - range.overscan, 0);
  const end = Math.min(range.endIndex + range.overscan, range.count - 1);

  const arr = [];

  for (let i = start; i <= end; i++) {
    arr.push(i);
  }

  return arr;
};
